import TextWidget from "views/logic/widgets/TextWidget";
import TextWidgetConfig from "views/logic/widgets/TextWidgetConfig";
import { addWidget } from "views/logic/slices/widgetActions";
const defaultText = `
Please edit me to set the text (Markdown) you want to display. You can include:
   - tables
   - images
   - links
   - lists 
   
and more.
`;
export const CreateTextWidget = () => TextWidget.builder().newId().config(new TextWidgetConfig(defaultText)).build();
export default () => (dispatch) => dispatch(addWidget(CreateTextWidget()));
